import { actionType, CRUD_ACTIONS, defaultPermissions } from './enums';

export function transformPermission(rules, customPermissions = []) {
	const permissions = !customPermissions.length ? defaultPermissions : customPermissions;

	return permissions.map(e => {
		const permissionsGroup =
			rules
				.filter(t => t.contextType === e.permissionType)
				.map(t => t.operationType);
		return {
			permissionType: e.permissionType,
			value: (() => {
				switch (permissionsGroup.length) {
				case 0: return actionType.none;
				case 1:
					return permissionsGroup[0] === actionType.read
						? actionType.read
						: actionType.none;
				default: {
					if (permissionsGroup.length === CRUD_ACTIONS.length) {
						return CRUD_ACTIONS.sort().join() === permissionsGroup.sort().join()
							? actionType.readAndWrite
							: actionType.none;
					} else {
						return actionType.none;
					}
				}
				};
			})(),
		}
	}) || []
}

export const transformedPermissionsAPI = permissions => {
	return permissions.map(e => ({
		contextType: e.permissionType,
		operationType: (() => {
			switch (e.value) {
			case actionType.none: return [actionType.none];
			case actionType.readAndWrite: return CRUD_ACTIONS;
			case actionType.read: return [actionType.read];
			}
		})()
	})).reduce((res, a) => {
		a.operationType.forEach(e => {
			res.push({ contextType: a.contextType, operationType: e })
		});
		return res;
	}, []);
}